export function handleSortList(list, getContent, sortTableAscending) {
  let sortedList = list.slice(0);

  sortedList.sort(function (a, b) {
    const x = String(getContent(a)).toLowerCase();
    const y = String(getContent(b)).toLowerCase();
    
    if (sortTableAscending) {
      return x < y ? -1 : x > y ? 1 : 0;
    } else {
      return x < y ? 1 : x > y ? -1 : 0;
    }
  });

  return sortedList;
}
